import * as React from 'react';
import { BadgeSVGProps } from '../../BadgeImage/BadgeImage.types';

export const RCnr = ({
	finish
}: BadgeSVGProps) => (
   <svg 
      version="1.1" 
      id="Layer_1" 
      xmlns="http://www.w3.org/2000/svg" 
      xmlnsXlink="http://www.w3.org/1999/xlink" 
      x="0px" 
      y="0px"
      viewBox="0 0 410.7 117.1" 
      enableBackground="new 0 0 410.7 117.1" 
      xmlSpace="preserve"
   >
      <g>
         <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="120.3084" y1="35.3557" x2="121.7545" y2="35.3557" gradientTransform="matrix(3.232555e-09 -72 -72 -3.232555e-09 2752.519 8772.1064)">
            <stop  offset="0" style={{ stopColor: '#072653' }} />
            <stop  offset="0.5339" style={{ stopColor: '#072551' }} />
            <stop  offset="0.7292" style={{ stopColor: '#07224A' }} />
            <stop  offset="0.8684" style={{ stopColor: '#061D3E' }} />
            <stop  offset="0.981" style={{ stopColor: '#05162E' }} />
            <stop  offset="1" style={{ stopColor: '#05142A' }} />
         </linearGradient>
         <path className="background-colour" fill="url(#SVGID_1_)" d="M405,95.4c0,8-6.5,14.5-14.5,14.5H23.3c-8,0-14.5-6.5-14.5-14.5V20.2c0-8,6.5-14.5,14.5-14.5h367.3
         c8,0,14.5,6.5,14.5,14.5V95.4z"/>
         <linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="206.187" y1="117.1326" x2="206.187" y2="-3.381154e-06">
            <stop  offset="0" style={{stopColor: finish.dark}} />
            <stop  offset="3.285236e-02" style={{ stopColor: finish.dark }} />
            <stop  offset="7.363299e-02" style={{ stopColor: finish.dark }} />
            <stop  offset="0.1218" style={{ stopColor: finish.dark }} />
            <stop  offset="0.1814" style={{ stopColor: finish.light }} />
            <stop  offset="0.2649" style={{ stopColor: finish.light }} />
            <stop  offset="0.4969" style={{ stopColor: finish.light }} />
            <stop  offset="0.7315" style={{ stopColor: finish.light }} />
            <stop  offset="0.816" style={{ stopColor: finish.light }} />
            <stop  offset="0.8762" style={{ stopColor: finish.dark }} />
            <stop  offset="0.9249" style={{ stopColor: finish.dark }} />
            <stop  offset="0.9661" style={{ stopColor: finish.dark }} />
            <stop  offset="0.9993" style={{ stopColor: finish.dark }} />
         </linearGradient>
         <path fill="url(#SVGID_2_)" d="M404.3,96.2h-6.5c0,2.2-0.9,4.2-2.3,5.6c-1.5,1.4-3.4,2.3-5.6,2.3H22.5c-2.2,0-4.2-0.9-5.6-2.3
         c-1.4-1.5-2.3-3.4-2.3-5.6V21c0-2.2,0.9-4.2,2.3-5.6c1.5-1.4,3.4-2.3,5.6-2.3h367.3c2.2,0,4.2,0.9,5.6,2.3c1.4,1.5,2.3,3.4,2.3,5.6
         v75.2H404.3h6.5V21c0-5.8-2.4-11.1-6.1-14.8c-3.8-3.8-9.1-6.1-14.8-6.1H22.5C16.8,0,11.5,2.4,7.7,6.1C3.9,9.9,1.6,15.2,1.6,21v75.2
         c0,5.8,2.4,11.1,6.1,14.8c3.8,3.8,9.1,6.1,14.8,6.1h367.3c5.8,0,11.1-2.4,14.8-6.1c3.8-3.8,6.1-9.1,6.1-14.8H404.3z"/>
      </g>
   </svg>
);
